import { IComponentOptions } from "angular";
import { ContractPatchBulkResultController } from "./controller";

export const vsComponentName = "contractPatchBulkResult";

export const contractPatchBulkResultComponentOptions: IComponentOptions = {
  controller: ContractPatchBulkResultController,
  controllerAs: "bulkUpdateResultController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    bulkUpdateResponse: "<",
  },
};
